import React, { Fragment } from 'react'

const ProfileHeader = () => {
    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12 dashBoard">
                        <h2>Profile</h2>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ProfileHeader
